<div class="grid delete-account-grid">
    <div id='delete-account-info'>{{trans('users.labels.profileDeletionInfo')}}</div>
    <div *ngIf='systems.hasSystems()' id='delete-account-info2'>{{trans('users.labels.profileDeletionInfo2')}}</div>
    <div *ngIf='systems.hasSystems()' id='delete-account-system-container'>
      <div class='delete-account-system' *ngFor="let s of getOwnedSystems()">
        <div class='delete-account-system-icon' inlineSVG="assets/images/system.svg"></div>
        <div class='delete-account-system-text'>{{s.name}}</div>
      </div>
    </div>
</div>